"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VALID_2D_EXTENSIONS = void 0;
exports.isValid2DFileType = isValid2DFileType;
const file_utils_1 = require("./file-utils");
exports.VALID_2D_EXTENSIONS = ['.gif', '.jpeg', '.jpg', '.png'];
function isValid2DFileType(filename) {
    const name = filename.toLowerCase();
    const extension = (0, file_utils_1.getFileExtension)(name);
    return exports.VALID_2D_EXTENSIONS.includes(extension);
}
//# sourceMappingURL=is-valid-2d-file-type.js.map